import PRODUCT from './product'
import PRODUCER from './producer'

export const FRAGMENT = {
  PRODUCT,
  PRODUCER,
}
